import { createSlice } from '@reduxjs/toolkit'

export const authSlice = createSlice({
  name: 'auth',
  initialState: {
    isAuth: false,
    isAdmin: false,
    isAdBlock: false
  },
  reducers: {
    authStatusUpdated: (state,action) => {
      return {
        isAuth: action.payload.isAuth,
        isAdmin: action.payload.isAuth ? !!action.payload.isAdmin : false,
        isAdBlock: false,
      }
    },
    adBlockerStatusUpdated: (state,action) => {
        return {
            ...state,
            isAdBlock: action.payload.isAdBlock,
        }
      },
  },
})

// Action creators are generated for each case reducer function
export const { authStatusUpdated,adBlockerStatusUpdated } = authSlice.actions

export default authSlice.reducer